import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=535db734&lang=pug"
import script from "./ActionItems.vue?vue&type=script&lang=ts"
export * from "./ActionItems.vue?vue&type=script&lang=ts"
import style0 from "./ActionItems.vue?vue&type=style&index=0&id=535db734&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports